import { Grid, useMediaQuery } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { FC, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { UserSubscriptions } from '../../utils/types'
import { PaymentContext } from '../PaymentStatus/PaymentStatus'
import PaymentDetails from './PaymentDetails'
import PaymentForm from './PaymentForm'
import { CheckoutContext } from '../../pages/Checkout'

const Checkout :FC = () => {
  const matchesXl = useMediaQuery('(min-width:1200px)')

  const {checkoutId} = useParams()
  const {activeStep} = useContext(PaymentContext)
  const {recurring_payment} = useContext(CheckoutContext)


  const { isLoading, isError, data, error, refetch, isSuccess } = useQuery(
    ["getUserSubscriptions", checkoutId],
    () => {
      return axios.get(`/user_subscriptions/${checkoutId}`)},
      {
        enabled: !!checkoutId && Boolean(activeStep === 1) && recurring_payment
      }
  );

 let userSubscriptions! : UserSubscriptions;

  if(isSuccess && data){
    userSubscriptions = data?.data?.data?.subscription;
  }
  
  return (
    <Grid container  
      columnSpacing={matchesXl ? 6: 0}
      rowSpacing={matchesXl ? 0: 6}
      sx={{
        mt: {
          xs: 0,
          lg: '1.5rem',
        }, 
        px:{xs: 0, sm: 4, md: 6, lg: 8}
      }}  
    >
      <Grid item xs={12} lg={6}>
        <PaymentDetails isSuccess={isSuccess} userSubscriptions={userSubscriptions}/>
      </Grid>
      <Grid item xs={12} lg={6} >
        <PaymentForm userSubscriptions={userSubscriptions}/>
      </Grid>
    </Grid>
    // <iframe
    //   src="data:text/html;charset=utf-8,<!doctype html><html lang='en' xmlns='http://www.w3.org/1999/xhtml'><head><meta charset='UTF-8'><meta name='viewport' content='width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'><meta http-equiv='X-UA-Compatible' content='ie=edge'><title>Document</title><style>body{width: 50%;margin: 200px auto;}.loader {border: 16px solid #f3f3f3;border-radius: 50%;border-top: 16px solid #3498db;width: 120px;height: 120px;-webkit-animation: spin 2s linear infinite;animation: spin 2s linear infinite;}@-webkit-keyframes spin {0% { -webkit-transform: rotate(0deg); }100% { -webkit-transform: rotate(360deg); }}@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}</style></head><body><div class='loader'></div><form id='payment-form' action='https://testsecureacceptance.cybersource.com/pay' method='post'><input type='hidden' name='access_key' value='5d13ee8638b6304eb2116d2a1d30a168'><input type='hidden' name='profile_id' value='C15A10CC-C446-403B-8973-1F351FE490DD'><input type='hidden' name='transaction_uuid' value='5a93fdc6-3a7e-4fd2-afb2-f5e8534d3d9f'><input type='hidden' name='signed_field_names' value='access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,merchant_defined_data1,merchant_defined_data2,merchant_defined_data3'><input type='hidden' name='unsigned_field_names' value=''><input type='hidden' name='signed_date_time' value='2024-03-22T13:08:18Z'><input type='hidden' name='locale' value='en'><input type='hidden' name='transaction_type' size='25' value='sale'><input type='hidden' name='reference_number' size='25' value='1711112898963'><input type='hidden' name='amount' size='25' value='1.0'><input type='hidden' name='currency' size='25' value='USD'><input type='hidden' name='merchant_defined_data1' size='25' value='sewasew'><input type='hidden' name='merchant_defined_data2' size='25' value='3e6d5c92-ff6e-4232-bbe3-37b411352e0e'><input type='hidden' name='merchant_defined_data3' size='25' value='321'><input type='hidden' name='signature' size='25' value='aCVSh6BT7ieUv1BhzGxIO0x3BgTsivgUC7Apegtq/WQ='></form><script>window.onload = function(){document.forms['payment-form'].submit();}</script></body></html>"
    //   title="Embedded Payment Form"
    //   width="100%"
    //   height="100%"
    //   frameBorder="0"
    // />
  )
}

export default Checkout